import { render, staticRenderFns } from "./WorkBookChapterScore.vue?vue&type=template&id=6934d116&scoped=true&"
import script from "./WorkBookChapterScore.vue?vue&type=script&lang=js&"
export * from "./WorkBookChapterScore.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookChapterScore.vue?vue&type=style&index=0&id=6934d116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934d116",
  null
  
)

export default component.exports